import Vue from "vue";

const formService = {
  _app: null,
  init(app, events = true) {
    this._app = app;
    if (events) {
      // gestione label / lingua
      this._app.$root.$on("lang:change", (label) => {
        // this._app.labels = label;
        Vue.set(this._app, "labels", label);
      });
      this._app.$root.$emit("lang:request", this._app.$store.lang);
      // filtri persistenti
      if (this._app.$store.form) {
        this._app.form = this._app.$store.form;
      }
    }
  },
  /**
   * @param {string} hex Color in HTML form with or without '#'
   * @returns {{ r: number, g: number, b: number }}
   */
  HEXtoRGB(hex) {
    hex = hex.trim().replace(/^#/g, "");
    return {
      r: parseInt(hex.substring(0, 2), 16),
      g: parseInt(hex.substring(2, 4), 16),
      b: parseInt(hex.substring(4, 6), 16)
    };
  },
  brightness(hex, value) {
    const { r, g, b } = this.HEXtoRGB(hex);
    let red, green, blue;
    if (value >= 0) {
      red = (0 | ((1 << 8) + r + ((256 - r) * value) / 100))
        .toString(16)
        .substr(1);
      green = (0 | ((1 << 8) + g + ((256 - g) * value) / 100))
        .toString(16)
        .substr(1);
      blue = (0 | ((1 << 8) + b + ((256 - b) * value) / 100))
        .toString(16)
        .substr(1);
    } else {
      red = (0 | ((1 << 8) + (r * (100 + value)) / 100)).toString(16).substr(1);
      green = (0 | ((1 << 8) + (g * (100 + value)) / 100))
        .toString(16)
        .substr(1);
      blue = (0 | ((1 << 8) + (b * (100 + value)) / 100))
        .toString(16)
        .substr(1);
    }
    return "#" + red + green + blue;
  },
  perceivedBrightness(hex) {
    const { r, g, b } = this.HEXtoRGB(hex);
    return Math.floor(
      Math.sqrt(
        Math.pow(r, 2) * 0.299 + Math.pow(g, 2) * 0.587 + Math.pow(b, 2) * 0.114
      )
    );
  },
  lastIndex(array, condition) {
    var index = [...array].reverse().findIndex(condition);
    return array.length - (index + 1);
  },
  /**
   * Format a number into a price string
   * @param {number} number
   * @returns {string}
   */
  formatPrice(number) {
    const formatter = new Intl.NumberFormat(undefined, {
      minimumFractionDigits: 2,
      useGrouping: true
    });
    return formatter.format(number);
  },
  /**
   * Parse a price-formatted string and converts it back to a number
   * @param {string} string
   * @returns {number}
   */
  parsePrice(string) {
    return +string.trim().replaceAll(".", "").replace(",", ".");
  },
  _upper(str) {
    if (str) {
      return str.toUpperCase();
    }
    return str;
  },
  /**
   * Based on the runtime type it parse a price string into a number or vice-versa\
   * for more details check the functions {@link formService.formatPrice} and {@link formService.parsePrice}
   * @param {number|string} value
   * @returns
   */
  _price(value) {
    if (typeof value === "string") {
      return this.parsePrice(value);
    }
    if (typeof value === "number") {
      return this.formatPrice(value);
    }
    return value;
  },
  _toStr(float) {
    float = "" + parseFloat(float).toFixed(2);
    return float.replace(".", ",");
  },
  _toFloat(str) {
    if (typeof str === "number") {
      return parseFloat(str);
    } else {
      return parseFloat(str.replace(",", "."));
    }
  }
};
export default formService;
